import accordion from './blocks/accordion';
import expandableContent from './blocks/expandable-content';
import faq from './blocks/faq';
import hero from './blocks/hero';
import titleCta from './blocks/title-cta';
import video from './blocks/video';
import megaMenu from './components/mega-menu';
import mobileMenu from './components/mobile-menu';
import search from './components/search';
import stickyHeader from './components/sticky-header';
import global from './general/global';
import scroll from './general/scroll';
import info from './swiper/info';
import locations from './swiper/locations';
import staff from './swiper/staff';
import textWithImage from './swiper/text-with-image';
import aditionalInfo from './blocks/imageText';

let globalObject = global;

document.addEventListener('DOMContentLoaded', () => {
    if (jQuery(window).width() >= 1024) {
        stickyHeader();
    } else {
        mobileMenu();
    }

    if (jQuery('section.hero').length > 0) {
        hero();
    }

    if (jQuery('section.expandable-content').length > 0) {
        expandableContent();
    }

    if (jQuery('section.faq').length > 0) {
        faq();
    }

    if (jQuery('section.accordion').length > 0) {
        accordion();
    }

    if (jQuery('.mega-menu').length > 0 && jQuery(window).width() >= 1024) {
        megaMenu();
    }

    if ('.search') {
        search();
    }

    if (jQuery('section.text-with-image').length > 0 && jQuery(window).width() < 1024) {
        textWithImage.initializeSwiper();
    }

    if (jQuery('section.info').length > 0) {
        info.initializeSwiper();
    }

    if (jQuery('section.locations').length > 0) {
        locations.initializeSwiper();
    }

    if (jQuery('section.video').length > 0) {
        video();
    }

    if (jQuery('section.title-cta').length > 0) {
        titleCta();
    }

    if (jQuery('section.staff').length > 0) {
        staff();
    }

    if (jQuery('.js-aditional-info').length > 0) {
        aditionalInfo();
    }

    scroll();
});
